import { ProductUnitCode } from '../enums/productUnitCode'

const productUnitCodes = new Set<string>(Object.values(ProductUnitCode))

export const isProductUnitCode = (code: string): code is ProductUnitCode => productUnitCodes.has(code)
